import React from 'react';
import { useRefetchFeedback } from '../feedback/useRefetchFeedback';

interface CardProps {
  children: React.ReactNode;
  loading?: boolean;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
  'data-testid'?: string;
}

const MetronicCard: React.FC<CardProps> = ({ children, loading = false, className = '', style, id, ...rest }) => {
  const feedbackVisible = useRefetchFeedback(loading);
  const contentAttributes = feedbackVisible ? { inert: '' } : {};

  return (
    <div
      aria-busy={loading}
      className={`card metronic-card ${feedbackVisible ? 'metronic-card--loading' : ''} ${className}`}
      data-testid={rest['data-testid']}
      id={id}
      style={style}
    >
      {feedbackVisible ? <span aria-hidden="true" className="metronic-card-progress" /> : null}
      <div className="metronic-card-content w-100 h-100" {...contentAttributes}>
        {children}
      </div>
    </div>
  );
};

export default MetronicCard;
